// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"589":"8b9e5b60","679":"a5018190","945":"a5018190"}[chunkId] + ".chunk.css";
};